<template>
    <div class="w-full h-[76vw] relative overflow-hidden flex justify-center">
        <img src="../../assets/img/Desktop/DeepStrategy/1.webp" alt="" class="w-full h-auto absolute top-0 left-0">
        <div class="w-full h-[0.1vw] bg-gradient-to-r from-transparent to-transparent via-white absolute top-0 left-0">
        </div>
        <img src="../../assets/img/Desktop/DeepStrategy/4.webp" alt=""
            class="absolute top-[8.5vw] left-[5vw] rotate-[-7deg] w-[33.5vw]">
        

        <!-- elip 1 -->
        <div class="h-[26vw] w-[22vw] bg-[#FEF2A6] absolute top-[41.5vw] left-[8.5vw] rounded-[50%] blur-[10.5vw]"></div>
        <!-- elip 2 -->
        <div class="w-[19vw] h-[19vw] bg-[#FF6659] rounded-[50%] absolute top-[20vw] right-[8.5vw] rotate-[-35deg] blur-[10.5vw]"></div>
        <!-- text -->
        <div class="absolute top-[10.5vw] right-[8.5vw] flex flex-col items-end">
            <p class="text-end font-emeritus text-white text-[4.17vw] leading-[4.17vw] uppercase [text-shadow:0.2vw_0.2vw_#00000025]">
                Deep Strategy
            </p>
            <p class="text-end font-emeritus text-white text-[4.17vw] leading-[4.17vw] uppercase [text-shadow:0.2vw_0.2vw_#00000025]">
                Effortless Progress
            </p>
            <p class="font-league text-white text-[1.055vw]">
                Freely arrange your team, activate skills, and watch your army auto-battle and gather resources—even while you're offline.
            </p>
        </div>
        <img src="../../assets/img/Desktop/DeepStrategy/Object 2.webp" alt="" class="absolute bottom-0 w-[2vw] left-[28vw]">
        <img src="../../assets/img/Desktop/DeepStrategy/Object 2.webp" alt="" class="absolute bottom-0 w-[2vw] right-[28vw]">
        <!-- main -->
        <div class="absolute top-[25vw] w-[68vw] flex flex-col items-center">
            <img src="../../assets/img/Desktop/DeepStrategy/5.webp" alt="" class="w-[20.9375vw]">
            <div class="w-[66.5vw] h-[37.1vw] relative flex justify-center bg-gradient-to-b from-transparent to-transparent via-white">
                <img src="../../assets/img/Desktop/DeepStrategy/2.webp" alt="" class="w-[66.3vw] absolute">
            </div>
            <img src="../../assets/img/Desktop/DeepStrategy/6.webp" alt="" class="w-[20.9375vw]">
        </div>
        <img src="../../assets/img/Desktop/DeepStrategy/3.webp" alt="" class="w-[27vw] absolute top-[54vw] right-[2vw] rotate-[10deg]">
    </div>
</template>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}
</style>